var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 7.17104H14.5112C12.9409 7.17104 11.668 8.44397 11.668 10.0142V19.4915C11.668 21.0617 12.9409 22.3346 14.5112 22.3346H23.9887C25.559 22.3346 26.832 21.0617 26.832 19.4915L26.832 14.7528M16.4067 17.596L19.8549 16.9012C20.038 16.8643 20.2061 16.7742 20.3381 16.6421L28.0572 8.91894C28.4273 8.54865 28.4271 7.94844 28.0567 7.57847L26.4215 5.94517C26.0512 5.57535 25.4513 5.5756 25.0813 5.94573L17.3614 13.6697C17.2296 13.8015 17.1397 13.9692 17.1028 14.1519L16.4067 17.596Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEditicon);
export default __webpack_public_path__ + "static/media/White_editicon.3c122544d2d91a3c15568baaf263fc1f.svg";
export { ForwardRef as ReactComponent };